/**
 * Get the CSP nonce from the meta tag in the document head.
 * The nonce is set by Rails in the layout templates.
 *
 * @returns The CSP nonce string, or undefined if not available
 */
export function getCspNonce(): string | undefined {
  if (typeof document === "undefined") {
    return undefined;
  }

  const metaTag = document.querySelector('meta[name="csp-nonce"]');
  return metaTag?.getAttribute("content") || undefined;
}
